import { useBreakpoint } from '@vivaldis/antd-ui'
import { useUser } from '@vivaldis/session'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Suspense } from 'react'
import { ProgressBarSuspenseFallback } from '@vivaldis/web-ui'
import { ProtectedRoute } from '../../components/ProtectedRoute'
import { lazyOrReloadPage } from '../../utils/lazyOrReloadPage'
import { DimonaAttestationRoutes } from './screens/DimonaAttestation/routes'

const Profile = lazyOrReloadPage(
  () => import(/* webpackChunkName: "Profile" */ './screens/Profile')
)
const Company = lazyOrReloadPage(
  () => import(/* webpackChunkName: "Company" */ './screens/Company')
)
const CompanyUsers = lazyOrReloadPage(
  () => import(/* webpackChunkName: "CompanyUsers" */ './screens/CompanyUsers')
)
const CostPlaces = lazyOrReloadPage(
  () => import(/* webpackChunkName: "CostPlaces" */ './screens/CostPlaces')
)
const EmailSettings = lazyOrReloadPage(
  () =>
    import(/* webpackChunkName: "EmailSettings" */ './screens/EmailSettings')
)
const Offers = lazyOrReloadPage(
  () => import(/* webpackChunkName: "Offers" */ './screens/Offers')
)
const AddCompanyUser = lazyOrReloadPage(
  () =>
    import(/* webpackChunkName: "AddCompanyUser" */ './screens/AddCompanyUser')
)
const AddCostPlace = lazyOrReloadPage(
  () => import(/* webpackChunkName: "AddCostPlace" */ './screens/AddCostPlace')
)
const Settings = lazyOrReloadPage(
  () => import(/* webpackChunkName: "Settings" */ './screens/Settings')
)
const ViewCompanyUser = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "ViewCompanyUser" */ './screens/ViewCompanyUser'
    )
)

export const SettingsRoutes = () => {
  const breakpoint = useBreakpoint()

  const showCostPlaces = !!useUser()?.company?.costPlacesEnabled

  return (
    <Suspense fallback={ProgressBarSuspenseFallback}>
      <Routes>
        <Route path="/" element={breakpoint.lg ? <Profile /> : <Settings />} />
        <Route path="profile" element={<Profile />} />
        <Route path="company" element={<Company />} />
        <Route path="company-users" element={<CompanyUsers />} />
        <Route
          path="cost-places"
          element={
            <ProtectedRoute isAllowed={showCostPlaces}>
              <CostPlaces />
            </ProtectedRoute>
          }
        />
        <Route
          path="dimona-attestation/*"
          element={<DimonaAttestationRoutes />}
        />
        <Route path="email-settings" element={<EmailSettings />} />
        {/* Redirect: In old mails we use "/settings/mail-management" */}
        <Route
          path="mail-management"
          element={<Navigate to="/settings/email-settings" replace />}
        />
        <Route path="offers" element={<Offers />} />
        <Route path="add-cost-place" element={<AddCostPlace />} />
        <Route
          path="company-users/add-company-user"
          element={<AddCompanyUser />}
        />
        <Route path="company-users/:id" element={<ViewCompanyUser />} />
      </Routes>
    </Suspense>
  )
}
